// vorgangsMailsErben.ts — P9: die Post des Vorgangs an einen eben angelegten
// Termin hängen. Aus dem früheren TerminLightDialog herausgelöst, seit die
// Neuanlage wieder im großen Termin-Fenster läuft (PO 28.09.2026).

import { calendarTerminService } from "../../services/calendarTerminService";
import { uebernahmeHinweis } from "../vorgang/detail/vorgangTermine";
import { zeigeGlobalenHinweis } from "./globalerHinweis";

/**
 * Best-effort und BEWUSST nach der Verknüpfung: die Verknüpfung ist die Zusage,
 * die Mail-Übernahme ihr Nebeneffekt. Scheitert sie, bleibt der Termin
 * verknüpft — gesagt wird es trotzdem, statt den Nutzer glauben zu lassen, die
 * Post hinge dran. Der Weg ist der globale Hinweis: er erreicht den Nutzer auch
 * dann, wenn das auslösende Fenster schon zu ist.
 *
 * Gemeldet wird nur, wenn es etwas zu melden gibt — „keine Mails am Vorgang"
 * ist beim Anlegen eines Termins keine Nachricht, sondern Rauschen.
 */
export async function erbeVorgangsMails(
    mailbox: string,
    eventId: string,
    vorgangId: number,
): Promise<void> {
    try {
        const ergebnis = await calendarTerminService.uebernimmVorgangsMails(mailbox, eventId, vorgangId);
        if (ergebnis.angelegt > 0 || ergebnis.ausgelassen > 0) {
            zeigeGlobalenHinweis(uebernahmeHinweis(ergebnis));
        }
    } catch (err: any) {
        console.error("[Termin] Mail-Übernahme fehlgeschlagen", err);
        zeigeGlobalenHinweis(
            "Der Termin ist mit dem Vorgang verknüpft, seine Mails konnten aber nicht übernommen werden.",
            { art: "fehler" },
        );
    }
}
